import React from "react";
import { TailSpin } from "react-loader-spinner";

export default function Loader({ color, height = 60, width = 60, wrapperStyle = {} }) {
  return (
    <div style={{ textAlign: "center", top: "50%", position: "absolute", left: "calc(50% - 50px)", ...wrapperStyle }}>
      <TailSpin color={color} height={height} width={width} />
    </div>
  );
}
